import { useMemo } from 'react';

export function useOptionsListForDynamicSelect<
  Id extends string | number,
  ItemQueryHook extends (id: Id, opts?: { skip?: boolean }) => any,
  ListQueryHook extends (arg: any, opts?: { skip?: boolean }) => any,
>({
  itemId,
  useGetItemQuery,
  useGetListQuery,
  filter,
  skipList,
  skipItem,
  readyItem,
  queryParams,
  skipAddingItemToOptionListOn,
}: {
  itemId?: Id;
  useGetItemQuery: ItemQueryHook;
  useGetListQuery: ListQueryHook;
  filter?: string;
  skipList?: boolean;
  skipItem?: boolean;
  readyItem?: any;
  queryParams?: any;
  skipAddingItemToOptionListOn?: (item: any) => boolean;
}) {
  const { data: item, ...itemQuery } = useGetItemQuery(itemId, {
    skip: !itemId || skipItem || !!readyItem,
  });

  const { isLoading, isFetching } = itemQuery;

  const listQueryArg = useMemo(
    () => ({ filter, ...queryParams }),
    [filter, queryParams],
  );

  const { data: items = [], ...listQueryRaw } = useGetListQuery(listQueryArg, {
    skip: isLoading || isFetching || skipList,
  });

  const list = useMemo(() => {
    if (
      item &&
      !items.some(x => x.id === item.id) &&
      !skipAddingItemToOptionListOn?.(item) &&
      !!itemId
    ) {
      return [item, ...items];
    }
    return items;
  }, [item, items, skipAddingItemToOptionListOn, itemId]);

  const listQuery = listQueryRaw;

  return { list, listQuery, item, itemQuery };
}
